function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 11.836,
    viewBox: "0 0 20 11.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.258.118c1.734.4 2.4 1.416 3.229 2.812h-3.229zM4.124 3.047a.514.514 0 0 1 .586.547.586.586 0 0 1-.584.586H.586a.586.586 0 0 0 0 1.172h5.273a.586.586 0 1 1 0 1.172H.586a.586.586 0 0 0 0 1.172h1.289v1.757a.586.586 0 0 0 .586.586h1.178a2.247 2.247 0 0 0 4.4 0h5.951a2.247 2.247 0 0 0 4.4 0h1.022A.586.586 0 0 0 20 9.453V5.938A1.891 1.891 0 0 0 18.185 4.1h-4.513a.586.586 0 0 1-.586-.586V0H2.461a.586.586 0 0 0-.586.586v1.289h-.7a.586.586 0 0 0 0 1.172zM16.951 8.83a1.074 1.074 0 1 1-1.834.76 1.074 1.074 0 0 1 1.834-.76zM6.6 8.83a1.074 1.074 0 1 1-1.834.76A1.074 1.074 0 0 1 6.6 8.83zm0 0",
    style: {
      fill: "#bf2600",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/fast-delivery.975adf37a8022437a7d184d94f0bf3f7.svg";
export { ForwardRef as ReactComponent };